import React from 'react'
import { useLocale } from '../contexts/LocaleContext'

/**
 * A slice of a real organiser's day, overlapping the photo above it. Shows the shape
 * of the product before anyone has to read a feature list.
 */
const ProductProof: React.FC = () => {
  const { t } = useLocale()

  return (
    <section className="relative z-[2] -mt-12 flex justify-center px-5 pb-16 sm:px-8 lg:px-14 lg:pb-[88px]">
      <div className="w-full max-w-[720px] rounded-xl border border-border bg-surface-card p-6 shadow-raised">
        <div className="flex items-center justify-between gap-3">
          <span className="text-base font-semibold">{t('proof.date')}</span>
          <span className="inline-flex items-center gap-1.5 rounded-sm border-l-[3px] border-status-success bg-status-success-bg px-2.5 py-1 text-xs font-semibold text-status-success-text">
            <span aria-hidden>▸</span>
            {t('proof.active')}
          </span>
        </div>

        <div className="mt-4 flex gap-3">
          <div className="flex-1 rounded-md bg-surface-page p-3.5">
            <div className="font-display text-2xl font-bold">42</div>
            <div className="text-xs text-text-secondary">{t('proof.volunteers')}</div>
          </div>
          <div className="flex-1 rounded-md bg-surface-page p-3.5">
            <div className="font-display text-2xl font-bold">17</div>
            <div className="text-xs text-text-secondary">{t('proof.shifts')}</div>
          </div>
          <div className="flex-1 rounded-md bg-surface-page p-3.5">
            <div className="font-display text-2xl font-bold text-status-warning-text">3</div>
            <div className="text-xs text-text-secondary">{t('proof.stillOpen')}</div>
          </div>
        </div>

        <div className="mt-4 flex flex-col gap-2.5">
          <div className="flex items-center gap-3 rounded-md border border-border px-3 py-2.5">
            <span
              aria-hidden
              className="inline-flex h-7 w-7 items-center justify-center rounded-full text-[11px] font-bold text-white"
              style={{ background: '#2B6E8C' }}
            >
              JB
            </span>
            <span className="flex-1 text-sm font-semibold">Glühweinstand · 16:00</span>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-status-success-text">
              <span aria-hidden className="text-sm text-status-success">
                ◉
              </span>
              {t('proof.checkedIn')}
            </span>
          </div>

          <div className="flex items-center gap-3 rounded-md border border-border px-3 py-2.5">
            <span
              aria-hidden
              className="inline-flex h-7 w-7 items-center justify-center rounded-full text-[11px] font-bold text-white"
              style={{ background: '#6D4FA1' }}
            >
              MV
            </span>
            <span className="flex-1 text-sm font-semibold">Kassa · 12:00</span>
            <span className="inline-flex items-center gap-1.5 rounded-pill border-[1.5px] border-status-info px-2.5 py-1 text-xs font-semibold text-status-info-text">
              <span aria-hidden>→</span>
              {t('proof.assigned')}
            </span>
          </div>

          <div>
            <div className="mb-1 flex justify-between text-xs">
              <b>Opbouw · 6 / 8</b>
              <span className="font-semibold text-capacity-filling">
                {t('proof.almostFull')}
              </span>
            </div>
            <div className="h-2 overflow-hidden rounded-sm bg-surface-sunken">
              <div className="h-full w-3/4 bg-capacity-filling" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductProof
